export default {
	ido_contact_person_actions: 'Actions',
	ido_contact_person_cancel: 'Cancel',
	ido_contact_person_close_edit_dialog: 'Close',
	ido_contact_person_confirm_delete_message: 'Do you really want to delete the entry?',
	ido_contact_person_confirm_delete_title: 'Confirm delete',
	ido_contact_person_create: 'Create',
	ido_contact_person_delete: 'Delete',
	ido_contact_person_edit: 'Edit',
	ido_contact_person_save: 'Save',
};
